"use strict";
const firebase = require('firebase');
const moment = require('moment');
const m = require('../models');
const path = require('./path');
class Database {
    initialize() {
        this.database = firebase.database();
    }
    listenToConnection(callback) {
        const connectedRef = this.database.ref('.info/connected');
        connectedRef.on('value', snap => callback(snap.val()));
    }
    listenToTasks(uid, callback) {
        const ref = this.database.ref(path.tasks(uid));
        ref.orderByKey();
        ref.on('child_added', childData => callback('child_added', childData.val()));
        ref.on('child_changed', childData => callback('child_changed', childData.val()));
        ref.on('child_removed', childData => callback('child_removed', childData.key));
        return ref;
    }
    stopListeningToTasks(tasksRef) {
        return tasksRef.off();
    }
    saveTask(uid, task) {
        if (task.id) {
            return this.database.ref(path.task(uid, task.id)).set(task);
        }
        else {
            const newTaskRef = this.database.ref(path.tasks(uid)).push();
            task.id = newTaskRef.key;
            return newTaskRef.set(task);
        }
    }
    deleteTask(uid, task) {
        return this.database.ref(path.task(uid, task.id)).remove();
    }
    startTask(uid, task) {
        // Create a new session.
        const now = new Date();
        const date = moment(now).format('YYYY-MM-DD');
        const sessionsPath = path.taskSessions(uid, task.id, date);
        const sessionPush = this.database.ref(sessionsPath).push({
            startedAt: now.getTime(),
        });
        // Update task.
        const taskUpdate = this.database.ref(path.task(uid, task.id)).update({
            state: 1 /* RUNNING */,
            currentSessionPath: sessionsPath + '/' + sessionPush.key,
        });
        return firebase.Promise.all([
            sessionPush,
            taskUpdate
        ]);
    }
    stopTask(uid, task) {
        // End current session.
        const now = new Date();
        const sessionRef = this.database.ref(task.currentSessionPath);
        const sessionUpdate = sessionRef.update({
            stoppedAt: now.getTime(),
        });
        // Update task.
        const taskRef = this.database.ref(path.task(uid, task.id));
        const taskUpdate = taskRef.update({
            state: 0 /* STOPPED */,
            currentSessionPath: null,
        });
        return firebase.Promise.all([
            sessionUpdate,
            taskUpdate,
        ]);
    }
    listenToSessions(uid, callback) {
        const ref = this.database.ref(path.sessions(uid));
        ref.orderByKey();
        ref.on('child_added', childData => callback('child_added', childData.key, childData.val()));
        ref.on('child_changed', childData => callback('child_changed', childData.key, childData.val()));
        return ref;
    }
    stopListeningToSessions(sessionsRef) {
        return sessionsRef.off();
    }
    getServerTimestamp() {
        return firebase.database.ServerValue.TIMESTAMP;
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Database;



/** WEBPACK FOOTER **
 ** ./src/api/database.ts
 **/